<popup [header]="viewForm.title" [(visible)]="display" modal="modal" [closable]="false" width="750" responsive="true"
    (onShow)="onShow()" (onHide)="onHide($event)">
    <div class="modal_area" *ngIf="display">
        <div class="modal_area" *ngIf="viewForm">

            <div class="ct">
                {{labelLeft}} <span class="txt_red">{{viewForm.userDeviceName}}</span> {{labelRight}}
            </div>
            <div class="ct">
                {{'有效時間剩餘'|i18n:'common00020003':null}}
                <span class="txt_red">{{viewForm.timeout}} {{'秒'|i18n:'chm00005832':null}}</span>
            </div>

        </div>

        <div class="btn_box">
            <commandButton [mask]="false" *ngIf="viewForm.timeout>0" styleClass="submit_btn reset" (onClick)="onHide($event)">
                {{'取消'|i18n:'common00003513':null}}</commandButton>
        </div>
    </div>
</popup>